import './Dictionary.css';

function Dictionary(props) {
  const { conjugation } = props;

  return (
    <div id="dictionary">
      <div className="dictionary__infinitive">{conjugation.verb}</div>
      <div className="dictionary__divider">-</div>
      <div className="dictionary__definition">{conjugation.definition}</div>
    </div>
  );
}

export default Dictionary;
